module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/agora/components/product-data/product-groups/details/product-group-details.component.css
// module id = ./src/app/agora/components/product-data/product-groups/details/product-group-details.component.css
// module chunks = main